/**
 * 企业级手册：正文由 Portal 服务端从 docs 动态读取并安全渲染。
 */

export function initHandbookToc() {
  document.querySelectorAll('.handbook-toc a').forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetId = this.getAttribute('href')?.slice(1);
      if (!targetId) return;
      const target = document.getElementById(targetId);
      const page = this.closest('.mock-page');
      const body = page?.querySelector('.handbook-body');
      if (target && body) {
        body.scrollTo({ top: Math.max(0, target.offsetTop - 16), behavior: 'smooth' });
      }
    });
  });
}

export function initEnterpriseHandbook() {
  const reader = document.getElementById('handbook-reader');
  const quickGuide = document.getElementById('handbook-quick-guide');
  const quickToc = document.getElementById('handbook-quick-toc');
  const documentElement = document.getElementById('handbook-document');
  const titleElement = document.getElementById('handbook-current-title');
  const scrollContainer = document.getElementById('handbook-scroll-container');
  const docButtons = Array.from(document.querySelectorAll('[data-doc-path]'));
  const quickButton = document.getElementById('handbook-show-quick');
  if (!reader || !quickGuide || !documentElement || !titleElement) return;

  let currentDocPath = '';
  let activeRequest = null;

  function toDocsUrl(path) {
    return '/docs/' + path.split('/').map(encodeURIComponent).join('/');
  }

  function setReaderVisible() {
    reader.hidden = false;
    quickGuide.hidden = true;
    if (quickToc) quickToc.hidden = true;
    quickButton?.classList.remove('active');
  }

  async function openDocument(path, hash = '') {
    if (!path || !path.toLowerCase().endsWith('.md')) return;
    setReaderVisible();
    docButtons.forEach((button) => {
      button.classList.toggle('active', button.dataset.docPath === path);
    });
    documentElement.innerHTML = '<div class="handbook-doc-status">正在加载手册……</div>';
    titleElement.textContent = '正在加载';
    activeRequest?.abort();
    activeRequest = new AbortController();

    try {
      const response = await fetch(toDocsUrl(path), {
        headers: { Accept: 'text/html' },
        signal: activeRequest.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const renderedHtml = await response.text();
      currentDocPath = path;
      // 服务端使用禁用原始 HTML 的 Markdown 渲染器，此处仅注入其受控输出。
      documentElement.innerHTML = renderedHtml;
      const documentTitle = documentElement.querySelector('h1')?.textContent?.trim();
      titleElement.textContent = documentTitle || '企业级使用手册';
      documentElement.querySelectorAll('a[href]').forEach((link) => {
        const href = link.getAttribute('href') || '';
        if (/^https?:\/\//i.test(href)) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
      });
      if (hash) {
        requestAnimationFrame(() => {
          const target = documentElement.querySelector(`#${CSS.escape(hash)}`);
          target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else {
        scrollContainer?.scrollTo({ top: 0, behavior: 'auto' });
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      titleElement.textContent = '手册加载失败';
      documentElement.innerHTML =
        '<div class="handbook-doc-status error">无法读取手册内容，请确认 Portal 服务已启动后重试。</div>';
    }
  }

  docButtons.forEach((button) => {
    button.addEventListener('click', () => openDocument(button.dataset.docPath || ''));
  });

  quickButton?.addEventListener('click', () => {
    reader.hidden = true;
    quickGuide.hidden = false;
    if (quickToc) quickToc.hidden = false;
    docButtons.forEach((button) => button.classList.remove('active'));
    quickButton.classList.add('active');
    scrollContainer?.scrollTo({ top: 0, behavior: 'auto' });
  });

  document.querySelectorAll('[data-open-handbook-doc]').forEach((button) => {
    button.addEventListener('click', () =>
      openDocument(button.dataset.openHandbookDoc || 'README.md'),
    );
  });

  documentElement.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('#')) {
      event.preventDefault();
      const target = documentElement.querySelector(
        `#${CSS.escape(decodeURIComponent(href.slice(1)))}`,
      );
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (/^(?:https?:|mailto:)/i.test(href)) return;
    const base = new URL(toDocsUrl(currentDocPath || 'README.md'), window.location.origin);
    const resolved = new URL(href, base);
    if (!resolved.pathname.startsWith('/docs/') || !resolved.pathname.toLowerCase().endsWith('.md')) {
      return;
    }
    event.preventDefault();
    const docPath = decodeURIComponent(resolved.pathname.slice('/docs/'.length));
    openDocument(docPath, decodeURIComponent(resolved.hash.slice(1)));
  });

  openDocument('README.md');
}
